export default "__VITE_ASSET__Dv5F4y_o__"